import { render, staticRenderFns } from "./settings-password-change.vue?vue&type=template&id=f0ad1814&"
import script from "./settings-password-change.vue?vue&type=script&lang=js&"
export * from "./settings-password-change.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports